export default __webpack_public_path__ + "static/media/strongloop.a8c5d37e.svg";